import styled from "styled-components";
import PieChart from "../../components/charts/PieChart";
import Users from "../users/Users";
import DemoData from "../../data/DemoData";
import StudentTicketItem from "./StudentTicketItem";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import ENDPOINT from "../../context/EndPoint";
import SecurityHeaders from "../../context/SecurityHeaders";
import GetStatistics from "../../actions/statistics/GetStatistics";

import AdminDeleteTickets from "../../actions/student/AdminDeleteTickets";
import AdminUpdateDoubtRequest from "../../actions/support/AdminUpdateDoubtRequest";
import {
  StudentDoubtSupportProvider,
  useContactRequests,
} from "../../context/support/StudentDoubtSupportContext";
import Localbase from "localbase";
import { useActionsContext } from "../../context/ActionsContext";
import { useDispatch } from "react-redux";
import CourseRegistrations from "../course-registrations/CourseRegistrations";
import DoubtSupportBarGrap from "../../components/charts/DoubtSupportBarGrap";
// import DashboardBargraph from "../../components/charts/DashboardBargraph";
function StudentsSupportPage({ options, permission }) {
  const { user } = useContext(AuthContext);
  const { rowsPerPage, setRowsPerPage } = useActionsContext(); // Moved earlier
  const userdata = user;
  const params = useParams();
  const [status, setstatus] = useState("all");
  const [query, setquery] = useState(null);
  const [resolutions, setresolutions] = useState(null);
  const [doubts, setdoubts] = useState(null);
  const [response, setResponse] = useState(doubts);
  const [searchTerm, setSearchTerm] = useState("");
  const { searchquery } = useActionsContext();
  const [toast, settoast] = useState(false);
  const [toasttitle, settoasttitle] = useState(null);
  const [info, setinfo] = useState(null);
  const [toastmessage, settoastmessage] = useState(null);
  const [requestDelete, setRequestDelete] = useState("");
  const [statistics, setstatistics] = useState(null);
  const [teamList, setTeamList] = useState([]);

const [view, setView] = useState("total");
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState(new Date().getMonth());
  const [weekIndex, setWeekIndex] = useState(0);

  const [monthsData, setMonthsData] = useState([]);
  const [weekData, setWeekData] = useState([]); // 🔑 SELECTED WEEK DATA

  const dispatch = useDispatch();
  const db = new Localbase("db");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const GetDoubts = async () => {
    dispatch({ type: "LOADING" });
    const data = new FormData();
    data.append("session", user.SessionId);
    data.append("limit", rowsPerPage); // Explicitly set limit to rowsPerPage
    if (status && status !== "all") {
      data.append("status", status); // Include status filter
    }
    if (query) {
      data.append("query", query); // Include search query
    }
    if (permission?.course_tickets_view) {
      data.append("course_tickets_view", permission.course_tickets_view);
    }

    try {
      const res = await axios.post(
        ENDPOINT + "admin-get-doubt-requests.php",
        data,
        {
          headers: {
            "content-type": "multipart/form-data",
          },
        }
      );

      if (res && res.data) {
        if (res.data.status === "success") {
          dispatch({ type: "DONE_LOADING" });
          setdoubts(res.data.data || []);
          setresolutions(
            res.data.resolutions || {
              unresolved: 0,
              resolved: 0,
              rejected: 0,
              total: 0,
            }
          );
          await db
            .collection("paths")
            .doc("doubts")
            .set({ doubts: res.data.data || [] });
        } else {
          dispatch({
            type: "ERROR",
            payload: res.data.message || "Failed to fetch doubts",
          });
        }
      } else {
        dispatch({ type: "ERROR", payload: "No response from server" });
      }
    } catch (error) {
      dispatch({
        type: "ERROR",
        payload: error.message || "Error fetching doubts",
      });
      console.error("Error fetching doubts:", error);
    }
  };

  useEffect(() => {
    db.collection("paths")
      .doc("doubts")
      .get()
      .then((data) => {
        if (data && data.doubts) {
          setdoubts(data.doubts);
        }
      });
    GetDoubts();
  }, [rowsPerPage, status, query]); // Added status and query as dependencies

  const GetStats = async () => {
    dispatch({ type: "LOADING" });
    try {
      const res = await GetStatistics({
        payload: { SessionId: user.SessionId },
      });
      if (res && res.status === "success") {
        dispatch({ type: "DONE_LOADING" });
        setinfo(res.data || null);
        await db
          .collection("paths")
          .doc("info")
          .set({ info: res.data || null });
      } else {
        dispatch({
          type: "ERROR",
          payload: res.error?.message || "Failed to fetch stats",
        });
      }
    } catch (error) {
      dispatch({
        type: "ERROR",
        payload: error.message || "Error fetching stats",
      });
      console.error("Error fetching stats:", error);
    }
  };

  useEffect(() => {
    db.collection("paths")
      .doc("info")
      .get()
      .then((data) => {
        if (data && data.info) {
          setinfo(data.info);
        }
      });
    GetStats();
  }, []);

  const Statistics = async () => {
    dispatch({ type: "LOADING" });
    const data = new FormData();
    data.append("session", user.SessionId);
    data.append("session", user.SessionId);
    data.append("year", year);
    data.append("month", month);
    data.append("week", weekIndex);
    data.append("view", view);

    try {
      const res = await axios.post(
        ENDPOINT + "doubts-statistics.php",
        data,
        SecurityHeaders
      );
      if (res && res.data && res.data.status === "success") {
        dispatch({ type: "DONE_LOADING" });
        setstatistics(res.data.data || null);
        await db
          .collection("paths")
          .doc("statistics")
          .set({ statistics: res.data.data || null });
      } else {
        dispatch({
          type: "ERROR",
          payload: res.data?.message || "Failed to fetch statistics",
        });
      }
    } catch (error) {
      dispatch({
        type: "ERROR",
        payload: error.message || "Error fetching statistics",
      });
      console.error("Error fetching statistics:", error);
    }
  };

  useEffect(() => {
    db.collection("paths")
      .doc("statistics")
      .get()
      .then((data) => {
        if (data && data.statistics) {
          setstatistics(data.statistics);
        }
      });
    Statistics();
  }, [user?.SessionId, year, month, weekIndex, view]);

  const getTeamList = async () => {
    dispatch({ type: "LOADING" });
    const data = new FormData();
    data.append("session", user.SessionId);
    try {
      const res = await axios.post(
        ENDPOINT + "get-team-list.php",
        data,
        SecurityHeaders
      );
      if (res && res.data && res.data.status === "success") {
        dispatch({ type: "DONE_LOADING" });
        setTeamList(res.data.data || []);
      } else {
        dispatch({
          type: "ERROR",
          payload: res.data?.message || "Failed to fetch team list",
        });
      }
    } catch (error) {
      dispatch({
        type: "ERROR",
        payload: error.message || "Error fetching team list",
      });
      console.error("Error fetching team list:", error);
    }
  };

  useEffect(() => {
    getTeamList();
  }, [user.SessionId]);

  const handleSearch = ({ term }) => {
    if (!term) {
      setResponse(doubts || []);
      setSearchTerm("");
      return;
    }

    if (term && doubts) {
      const filteredData = doubts.filter((item) => {
        return (
          (item.email &&
            item.email.toLowerCase().includes(term.toLowerCase())) ||
          (item.phone_number && item.phone_number.includes(term)) ||
          (item.first_name &&
            item.first_name.toLowerCase().includes(term.toLowerCase())) ||
          (item.last_name &&
            item.last_name.toLowerCase().includes(term.toLowerCase())) ||
          (item.create_datetime && item.create_datetime.includes(term)) ||
          (item.status &&
            item.status.toLowerCase().includes(term.toLowerCase()))
        );
      });
      setResponse(filteredData);
      setSearchTerm(term);
    }
  };

  useEffect(() => {
    handleSearch({ term: searchquery });
  }, [searchquery]);

  useEffect(() => {
    setResponse(doubts || []);
  }, [doubts]);

  const Reload = () => {
    GetDoubts();
  };
  return (
    <>
      {/* <DoubtSupportBarGrap
        monthsData={monthsData}
        weekData={weekData}
        view={view}
        setView={setView}
        year={year}
        setYear={setYear}
        month={month}
        setMonth={setMonth}
        weekIndex={weekIndex}
        setWeekIndex={setWeekIndex}
      /> */}
{/* 
      <DoubtSupportBarGrap
        statistics={statistics} // ← Ee object mottam backend nunchi vastundi
        view={view}
        setView={setView}
        year={year}
        setYear={setYear}
        month={month} // ← 0-11 (January = 0)
        setMonth={setMonth}
        weekIndex={weekIndex}
        setWeekIndex={setWeekIndex}
      /> */}
      <DoubtSupportBarGrap
  statistics={statistics}
  view={view}
  setView={setView}
  year={year}
  setYear={setYear}
  month={month}
  setMonth={setMonth}
  weekIndex={weekIndex}
  setWeekIndex={setWeekIndex}
/>
      <div className="container-fluid col-12">
        <div className="row">
          <div className="col">
            <div className="h-100">
              {/* {statistics ? (
                <div className="row g-3 mb-3">
                  <div className="col-lg-3 col-md-6 col-12">
                    <div className="card h-100">
                      <div className="card-body d-flex align-items-center">
                        <div className="avatar-sm">
                          <span className="avatar-title bg-light text-primary rounded-circle fs-3">
                            <i className="ri-arrow-down-circle-fill" />
                          </span>
                        </div>
                        <div className="ms-3 flex-grow-1">
                          <p className="text-uppercase text-muted mb-1">
                            Initiated
                          </p>
                          <h4>{statistics.total_initiated}</h4>
                        </div>
                        <span className="badge bg-danger-subtle text-danger">
                          {Math.round(statistics.percentage_initiated)}%
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12">
                    <div className="card h-100">
                      <div className="card-body d-flex align-items-center">
                        <div className="avatar-sm">
                          <span className="avatar-title bg-light text-success rounded-circle fs-3">
                            <i className="ri-check-double-fill" />
                          </span>
                        </div>
                        <div className="ms-3 flex-grow-1">
                          <p className="text-uppercase text-muted mb-1">
                            Closed
                          </p>
                          <h4>{statistics.total_closed}</h4>
                        </div>
                        <span className="badge bg-success-subtle text-success">
                          {statistics.percentage_closed}%
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12">
                    <div className="card h-100">
                      <div className="card-body d-flex align-items-center">
                        <div className="avatar-sm">
                          <span className="avatar-title bg-light text-info rounded-circle fs-3">
                            <i className="ri-file-list-3-fill" />
                          </span>
                        </div>
                        <div className="ms-3 flex-grow-1">
                          <p className="text-uppercase text-muted mb-1">
                            Total
                          </p>
                          <h4>{statistics.total_doubts}</h4>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12">
                    <div className="card h-100">
                      <div className="card-body d-flex align-items-center">
                        <div className="avatar-sm">
                          <span className="avatar-title bg-light text-warning rounded-circle fs-3">
                            <i className="ri-time-fill" />
                          </span>
                        </div>
                        <div className="ms-3 flex-grow-1">
                          <p className="text-uppercase text-muted mb-1">
                            Avg Resolution
                          </p>
                          <h4>
                            {parseInt(statistics.average_closed_time_minutes) >
                            60
                              ? `${Math.round(
                                  statistics.average_closed_time_minutes / 60
                                )} hrs`
                              : `${statistics.average_closed_time_minutes} mins`}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null} */}

              <div className="row">
                {/* end col sliding section*/}
                <div className="col-12  order-xxl-0 order-first p-0">
                  <div className="col-12 ">
                    <div className="card shadow-none shadow-md bg-transparent bg-md-white p-0">
                      <div className="col-12 d-none d-md-flex align-items-center p-3  justify-content-between">
                        <h5 className="m-0">Student Doubts</h5>
                        {options?.viewAll === false ? (
                          <></>
                        ) : (
                          <Link className="m-0" to="/students-support">
                            View All
                          </Link>
                        )}
                      </div>
                      {/* {options?.search === false ? null :
                       <div className="card-body border border-dashed border-end-0 border-start-0">
                        <form className="d-none d-sm-block d-lg-block d-xl-block ">
                          <div className="row g-3">
                            <div className="col-xxl-3 col-sm-4">
                              <div className="search-box">
                                <input
                                  onChange={(e)=>handleSearch({term:e.target.value.toLowerCase()})}

                                  type="text"
                                  className="form-control search"
                                  placeholder="Search for order ID, customer, order status or something..."
                                />
                                <i className="ri-search-line search-icon" />
                              </div>
                            </div>
                            <div className="col-xxl-2 col-sm-6 ">
                              <div>
                                <input
                                  type="date"
                                  onChange={(e)=>handleSearch({term:e.target.value.toLowerCase()})}


                                  className="form-control"
                                  data-provider="flatpickr"
                                  data-date-format="d M, Y"
                                  data-range-date="true"
                                  id="demo-datepicker"
                                  placeholder="Select date"
                                />
                              </div>
                            </div>
                            <div className="col-xxl-2 col-sm-4">
                              <div>
                                <select
                                  className="form-control"
                                  onChange={(e)=>handleSearch({term:e.target.value.toLowerCase()})}

                                  data-choices=""
                                  data-choices-search-false=""
                                  name="choices-single-default"
                                  id="idStatus"
                                >
                                  <option value="">Status</option>

                                  <option value="Pending">Pending</option>
                                  <option value="unresolved">Unresolved</option>
                                  <option value="closed">Closed</option>
                                  <option value="initiated">Initiated</option>
                                  <option value="resolved">Resolved</option>

                                </select>
                              </div>
                            </div>
        
                          </div>
                          
                        </form>
                      </div>
                      } */}
                      {/* end card header */}

                      <div className="card-body p-0 p-md-2 col-12">
                        <div className=" col-12">
                          <div className=" align-middle mb-0 col-12">
                            {/* <thead className="text-muted table-light">
                              <tr>
                             {options?.userinfo===false?null:   <th scope="cqol">User</th>}
                             {options?.course===false?null:   <th scope="cqol">course</th>
                             }
                                <th scope="col">Date</th>
                                <th scope="col">Status</th>
                                <th scope="col">Actions</th>

                            {options?.view===false?null:    <th scope="col">View</th>}
                              </tr>
                            </thead> */}
                            <>
                              {response ? (
                                <>
                                  {response.map((item) => (
                                    <>
                                      <StudentTicketItem
                                        Reload={Reload}
                                        item={item}
                                        options={options}
                                        key={item.id}
                                        teamList={teamList}
                                        Statistics={Statistics}
                                      />
                                    </>
                                  ))}
                                </>
                              ) : (
                                <></>
                              )}
                            </>
                            {/* end tbody */}
                          </div>
                          {/* end table */}
                        </div>
                      </div>
                    </div>{" "}
                  </div>

                  <div className="d-flex mt-4">
                    {/*Graphical data */}

                    <div className="col-lg-5 ps-3">
                      <div className="card"></div>
                    </div>

                    <div className="col-lg-5 ps-2"></div>
                  </div>
                </div>
                {/* end col */}
              </div>

              <div className="row">
                <div className="col-xl-8">{/* end card */}</div>
                {/* end col */}
                <div className="col-xl-4">
                  {/* card */}
                  <div className="card card-height-100">
                    {/* end card body */}
                  </div>
                  {/* end card */}
                </div>
                {/* end col */}
              </div>
            </div>{" "}
            {/* end .h-100*/}
          </div>{" "}
          {/* end col */}
          {/* end col */}
        </div>
      </div>
    </>
  );
}

export default StudentsSupportPage;

const StyledSuperAdminDashboard = styled.div`
  h1 {
    color: red;
  }
`;
